import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
//import { environment } from 'src/environments/environment';
import { RuntimeConfigService } from '../../../app/runtime-config.service'

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  constructor( private runtimeConfigService: RuntimeConfigService,){
  }
  private readonly secretKey = this.runtimeConfigService.localStorageKey // environment.LOCAL_STORAGE_SECRET_KEY;

  encryptAES(text: string): string {
    if (!text) {
      return '';
    }

    return CryptoJS.AES
      .encrypt(text, this.secretKey)
      .toString();
  }

  decryptAES(encryptedText: string): string {
    if (!encryptedText) {
      return '';
    }

    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedText,
        this.secretKey
      );

      return bytes.toString(
        CryptoJS.enc.Utf8
      );
    } catch (error) {
      console.error(
        'Unable to decrypt stored value',
        error
      );

      return '';
    }
  }
}
